import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { StarIcon as Star } from "@phosphor-icons/react";

export default function CsatSurvey() {
  const { token } = useParams();
  const [sp] = useSearchParams();
  const [info, setInfo] = useState(null);
  const [voto, setVoto] = useState(0);
  const [hover, setHover] = useState(0);
  const [commento, setCommento] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/csat/${token}`).then(({ data }) => {
      setInfo(data);
      if (data.status === "submitted") { setDone(true); setVoto(data.voto || 0); setCommento(data.commento || ""); }
      else { const pv = parseInt(sp.get("voto"), 10); if (pv >= 1 && pv <= 5) setVoto(pv); }
    }).catch((e) => setErr(e?.response?.data?.detail || "Sondaggio non trovato")).finally(() => setLoading(false));
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async () => {
    if (!voto) return;
    setSaving(true);
    try {
      const { data } = await axios.post(`${API}/public/csat/${token}`, { voto, commento });
      setInfo((i) => ({ ...i, thank_you: data.thank_you }));
      setDone(true);
    } catch (e) { setErr(e?.response?.data?.detail || "Errore durante l'invio"); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (err && !info) return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="text-center"><h1 className="text-xl font-semibold text-slate-800">Sondaggio non disponibile</h1><p className="text-slate-500 mt-2">{err}</p></div>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-lg bg-white rounded-lg shadow-sm border border-slate-200 p-8" data-testid="csat-survey">
        <div className="text-center mb-6">
          <div className="text-xs uppercase tracking-widest text-blue-600 font-semibold">Soddisfazione cliente</div>
          <div className="text-sm text-slate-400 mt-1">Ticket {info?.numero_ticket}</div>
        </div>
        {done ? (
          <div className="text-center py-6" data-testid="csat-done">
            <div className="flex justify-center gap-1 mb-4">
              {[1, 2, 3, 4, 5].map((n) => <Star key={n} size={30} weight="fill" className={n <= voto ? "text-amber-400" : "text-slate-200"} />)}
            </div>
            <h2 className="text-lg font-semibold text-slate-800">{info?.thank_you || "Grazie per il tuo feedback!"}</h2>
          </div>
        ) : (
          <>
            <div className="text-slate-700 text-sm mb-6 [&_p]:mb-2" dangerouslySetInnerHTML={{ __html: info?.intro || "" }} />
            <div className="flex justify-center gap-2 mb-6" data-testid="csat-stars">
              {[1, 2, 3, 4, 5].map((n) => (
                <button key={n} type="button" onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} onClick={() => setVoto(n)} data-testid={`csat-star-${n}`} className="transition-transform hover:scale-110 outline-none">
                  <Star size={42} weight={(hover || voto) >= n ? "fill" : "regular"} className={(hover || voto) >= n ? "text-amber-400" : "text-slate-300"} />
                </button>
              ))}
            </div>
            <textarea value={commento} onChange={(e) => setCommento(e.target.value)} rows={4} placeholder="Lascia un commento (facoltativo)" className="w-full border border-slate-200 rounded-md p-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" data-testid="csat-comment" />
            {err && <p className="text-sm text-red-500 mt-2">{err}</p>}
            <button onClick={submit} disabled={!voto || saving} data-testid="csat-submit" className="w-full mt-4 bg-blue-600 text-white rounded-md py-2.5 text-sm font-semibold disabled:opacity-40 hover:bg-blue-700 transition-colors">
              {saving ? "Invio…" : "Invia valutazione"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
